import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/app/userschema')({
  beforeLoad: () => {
    throw redirect({
      to: '/app/uppdrag',
    })
  },
})
